var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinFilled = function SvgCoinFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#coinFilled_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "coinFilled_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.516a8.484 8.484 0 1 0 0 16.968 8.484 8.484 0 0 0 0-16.968"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinFilled_svg__b)",
    d: "M10.5 1.516a8.484 8.484 0 1 0 0 16.968 8.484 8.484 0 0 0 0-16.968"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinFilled_svg__c)",
    d: "M10.5-.084C4.931-.084.416 4.431.416 10h3.2A6.884 6.884 0 0 1 10.5 3.116zM.416 10c0 5.569 4.515 10.084 10.084 10.084v-3.2A6.884 6.884 0 0 1 3.616 10zM10.5 20.084c5.569 0 10.084-4.515 10.084-10.084h-3.2a6.884 6.884 0 0 1-6.884 6.884zM20.584 10C20.584 4.43 16.069-.084 10.5-.084v3.2A6.884 6.884 0 0 1 17.384 10z",
    mask: "url(#coinFilled_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#coinFilled_svg__e)",
    fillRule: "evenodd",
    d: "m10.791 14.22-.001-.002-2.91-3.054a.5.5 0 0 1-.085-.626.54.54 0 0 1 .204-.193c.152-.084.343-.11.54-.11q.57.001 1.228-.178c.404-.11.696-.316.895-.616q.031-.048.056-.095H8.266c-.199 0-.392-.026-.543-.11a.523.523 0 0 1-.28-.467.52.52 0 0 1 .28-.465c.151-.084.344-.11.543-.11h2.224c-.347-.35-.887-.545-1.671-.545h-.553c-.199 0-.392-.026-.543-.11a.523.523 0 0 1-.28-.467.52.52 0 0 1 .28-.466c.151-.083.344-.109.543-.109h4.469c.198 0 .391.026.543.11a.523.523 0 0 1 .28.467.52.52 0 0 1-.28.466c-.152.083-.345.109-.543.109h-.781q.046.053.09.11.163.208.263.435h.428c.198 0 .391.026.543.11a.523.523 0 0 1 .28.467.52.52 0 0 1-.28.466c-.152.083-.345.109-.543.109h-.321a1.9 1.9 0 0 1-.267.602c-.298.451-.716.782-1.243.995q-.48.195-.957.303l2.206 2.317a.48.48 0 0 1 .137.326.49.49 0 0 1-.164.365.8.8 0 0 1-.33.168 1.1 1.1 0 0 1-.324.043c-.258 0-.505-.064-.68-.245",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinFilled_svg__c",
    x1: 10.5,
    x2: 10.5,
    y1: 1.516,
    y2: 18.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BB1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coinFilled_svg__e",
    x1: 10.5,
    x2: 10.5,
    y1: 6.497,
    y2: 14.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF4D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "coinFilled_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(109.359 6.395 5.283)scale(19.6087 52.1323)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B518"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "coinFilled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h20v20H.5z"
  })))));
};
export default SvgCoinFilled;